// extracted by mini-css-extract-plugin
export default {"LegendWrapper":"_LegendWrapper--HjKpz","LegendColor":"_LegendColor--QiNzr"};